import React from "react";
import Dropdown from "../Dropdown";
import spacetime from "spacetime";

const TimezoneSelect = ({ value, onChange }) => {
	const getDefaultValue = () => {
		const label = getOptions.find((x) => x.value === value).label;
		return { label: label, value: value };
	};

	const parseTimezone = (zone) => {
		if (!zone) return null;
		if (typeof zone === "object" && zone.value && zone.label) return zone;
		if (typeof zone === "string") {
			let finalZone = zone;
			if (!Object.keys(timezoness).includes(zone)) finalZone = "Asia/Kolkata";
			return getOptions.find((tz) => tz.value === finalZone);
		} else if (zone.value && !zone.label) {
			return getOptions.find((tz) => tz.value === zone.value);
		}
	};

	return (
		<Dropdown
			defaultValue={parseTimezone(value)}
			value={parseTimezone(value)}
			options={getOptions}
			onChange={onChange}
		/>
	);
};

const timezoness = {
	"Pacific/Midway": "Midway Island, Samoa",
	"Pacific/Honolulu": "Hawaii",
	"America/Juneau": "Alaska",
	"America/Tijuana": "Tijuana",
	"America/Los_Angeles": "Pacific Time",
	"America/Boise": "Mountain Time",
	"America/Dawson": "Dawson, Yukon",
	"America/Phoenix": "Arizona",
	"America/Chihuahua": "Chihuahua, La Paz, Mazatlan",
	"America/Chicago": "Central Time",
	"America/Regina": "Saskatchewan",
	"America/Mexico_City": "Guadalajara, Mexico City, Monterrey",
	"America/Belize": "Central America",
	"America/Detroit": "Eastern Time",
	"America/Bogota": "Bogota, Lima, Quito",
	"America/Caracas": "Caracas, La Paz",
	"America/St_Johns": "Newfoundland and Labrador",
	"America/Santiago": "Santiago",
	"America/Sao_Paulo": "Brasilia",
	"America/Montevideo": "Montevideo",
	"America/Argentina/Buenos_Aires": "Buenos Aires, Georgetown",
	"America/Godthab": "Greenland",
	"Atlantic/Azores": "Azores",
	"Atlantic/Cape_Verde": "Cape Verde Islands",
	"Etc/GMT": "UTC",
	"Europe/London": "Edinburgh, London",
	"Europe/Dublin": "Dublin",
	"Europe/Lisbon": "Lisbon",
	"Atlantic/Canary": "Canary Islands",
	"Africa/Casablanca": "Casablanca, Monrovia",
	"Europe/Belgrade": "Belgrade, Bratislava, Budapest, Ljubljana, Prague",
	"Europe/Sarajevo": "Sarajevo, Skopje, Warsaw, Zagreb",
	"Europe/Brussels": "Brussels, Copenhagen, Madrid, Paris",
	"Europe/Amsterdam": "Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
	"Africa/Algiers": "West Central Africa",
	"Europe/Bucharest": "Bucharest",
	"Africa/Cairo": "Cairo",
	"Europe/Helsinki": "Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
	"Europe/Athens": "Athens, Minsk",
	"Asia/Jerusalem": "Jerusalem",
	"Africa/Harare": "Harare, Pretoria",
	"Europe/Moscow": "Istanbul, Moscow, St. Petersburg, Volgograd",
	"Asia/Kuwait": "Kuwait, Riyadh",
	"Africa/Nairobi": "Nairobi",
	"Asia/Baghdad": "Baghdad",
	"Asia/Tehran": "Tehran",
	"Asia/Dubai": "Abu Dhabi, Muscat",
	"Asia/Baku": "Baku, Tbilisi, Yerevan",
	"Asia/Kabul": "Kabul",
	"Asia/Yekaterinburg": "Ekaterinburg",
	"Asia/Karachi": "Islamabad, Karachi, Tashkent",
	"Asia/Kolkata": "Chennai, Kolkata, Mumbai, New Delhi",
	"Asia/Colombo": "Sri Jayawardenepura",
	"Asia/Kathmandu": "Kathmandu",
	"Asia/Dhaka": "Astana, Dhaka",
	"Asia/Almaty": "Almaty, Novosibirsk",
	"Asia/Rangoon": "Yangon Rangoon",
	"Asia/Bangkok": "Bangkok, Hanoi, Jakarta",
	"Asia/Beirut": "Beirut, Lebanon",
	"Asia/Krasnoyarsk": "Krasnoyarsk",
	"Asia/Shanghai": "Beijing, Chongqing, Hong Kong SAR, Urumqi",
	"Asia/Kuala_Lumpur": "Kuala Lumpur, Singapore",
	"Asia/Taipei": "Taipei",
	"Australia/Perth": "Perth",
	"Asia/Irkutsk": "Irkutsk, Ulaanbaatar",
	"Asia/Seoul": "Seoul",
	"Asia/Tokyo": "Osaka, Sapporo, Tokyo",
	"Asia/Yakutsk": "Yakutsk",
	"Australia/Darwin": "Darwin",
	"Australia/Brisbane": "Brisbane",
	"Asia/Vladivostok": "Vladivostok",
	"Pacific/Guam": "Guam, Port Moresby",
	"Australia/Adelaide": "Adelaide",
	"Australia/Sydney": "Canberra, Melbourne, Sydney",
	"Australia/Hobart": "Hobart",
	"Asia/Magadan": "Magadan, Solomon Islands, New Caledonia",
	"Asia/Kamchatka": "Kamchatka, Marshall Islands",
	"Pacific/Fiji": "Fiji Islands",
	"Pacific/Auckland": "Auckland, Wellington",
	"Pacific/Tongatapu": "Nuku'alofa",
};

const getOptions = Object.entries(timezoness)
	.reduce((selectOptions, zone) => {
		const now = spacetime.now(zone[0]);
		const tz = now.timezone();
		// const tzStrings = soft(zone[0])

		let label = "";
		// let abbr = now.isDST()
		//   ? tzStrings[0].daylight.abbr
		//   : tzStrings[0].standard.abbr
		// let altName = now.isDST()
		//   ? tzStrings[0].daylight.name
		//   : tzStrings[0].standard.name

		const min = tz.current.offset * 60;
		const hr =
			`${(min / 60) ^ 0}:` + (min % 60 === 0 ? "00" : Math.abs(min % 60));
		const prefix = `(GMT${hr.includes("-") ? hr : `+${hr}`}) ${zone[1]}`;

		label = prefix;

		selectOptions.push({
			value: tz.name,
			label: label,
		});

		return selectOptions;
	}, [])
	.sort((a, b) => a.offset - b.offset);

export default TimezoneSelect;
